import Vue from 'vue'
import Buefy from 'buefy'
import router from './router'
import 'buefy/dist/buefy.css'
import store from './store'

Vue.use(Buefy, {
  defaultIconPack: 'fas'
})

import App from './App.vue'

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')

